import { useState, useEffect } from 'react';
import styles from '../../styles/components/Brands.module.css';

const Brands = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  // Brand images from the brands folder
  const brandImages = [
    '/Images/brands/atc.webp',
    '/Images/brands/beautypillow.png',
    '/Images/brands/blanco.png',
    '/Images/brands/magnum.png',
    '/Images/brands/novimed.png',
    '/Images/brands/nydirect.jpg',
    '/Images/brands/opontia.png',
    '/Images/brands/saje.png',
    '/Images/brands/saxx.png',
    '/Images/brands/silverjeans.png',
    '/Images/brands/suetables.png',
    '/Images/brands/wellca.png'
  ];

  //console.log(window.innerWidth);
  const totalSlides = window.innerWidth < 768 ? 3 : 2; // 3 slides total (0, 1, 2)
  //console.log(totalSlides);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => prevIndex >= totalSlides ? 0 : prevIndex + 1);
    }, 4000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className={styles.brandsSection}>
      <div className={styles.slideshowContainer}>
        <div 
          className={styles.slideshow}
          style={{ 
            transform: `translateX(-${currentIndex * 100}%)`,
            transition: 'transform 2s cubic-bezier(0.4, 0, 0.2, 1)'
          }}
        >
          {brandImages.map((image, index) => (
            <img 
              key={index}
              src={image}
              alt={`Brand ${index + 1}`}
              className={`${styles.brandImage}`}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default Brands;
